import { takeEvery, call, put, select, putResolve } from 'redux-saga/effects'
import createAction from 'loankeeper-common/helpers/createAction'

import { actions } from './constants'
import { getOldGraphicByRestrDate } from './selectors'
import { loanView } from 'src/store/loan'

function* fetchOldGraphic({ payload: { hash, RestrDate }, meta: { ID } }) {
  const oldGraphicByRestrDate = yield select((state) => getOldGraphicByRestrDate(state, ID, RestrDate))

  try {
    yield put(createAction(actions.FETCH, null, { ID }))

    // const { Data } = yield call(Loan.details, {
    //   page: 'schedule',
    //   ID,
    //   hash,
    //   additionalParams: {
    //     RestrDate,
    //   },
    // })

    //UPDATED API REQUEST loan_view_api page: 'schedule'
    const result = yield putResolve<any>(
      loanView({
        page: 'schedule',
        LoanID: ID,
        HashSum_LoanID_: hash,
        ActiveOperFlag: 1,
        RestrDate,
      }),
    )

    if (!loanView.fulfilled.match(result)) {
      throw { Error: { Message: result.payload } }
    }

    yield put(createAction(actions.FETCH_SUCCESS, { oldGraphic: result.payload }, { ID, RestrDate }))
  } catch (error) {
    console.error(error)
  }
}

export default function* () {
  //@ts-ignore
  yield takeEvery(actions.SWITCH_OLD_GRAPHIC, fetchOldGraphic)
}
